export default __webpack_public_path__ + "static/B0308-e55345b8d1772f0ba61bd5b7e12d0baf.png";